import { PagesConfigKey } from './pages-config';
import TitleWithBookmark from './title-with-bookmark';
import { useUserSettings } from '../utils/use-user-settings';
import Box from '@mui/material/Box';
interface SimplePageProps {
  title: string;
  pagesConfigKey: PagesConfigKey;
  children: React.ReactNode;
  showBookmark?: boolean;
  infoTooltip?: string;
}

export default function SimplePage({
  title,
  pagesConfigKey,
  children,
  showBookmark = true,
  infoTooltip,
}: Readonly<SimplePageProps>) {
  const { marketingOverview } = useUserSettings();
  const heightOfMarketingOverview = marketingOverview ? 48 : 0;

  return (
    <Box>
      <TitleWithBookmark
        title={title}
        bookmarkKey={pagesConfigKey}
        showBookmark={showBookmark}
        infoTooltip={infoTooltip}
      />
      <Box
        sx={{
          width: '100%',
          height: `calc(100vh - 130px - ${heightOfMarketingOverview}px)`,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
